import { render, staticRenderFns } from "./arsip.vue?vue&type=template&id=74289056&scoped=true&"
import script from "./arsip.vue?vue&type=script&lang=js&"
export * from "./arsip.vue?vue&type=script&lang=js&"
import style0 from "./arsip.vue?vue&type=style&index=0&id=74289056&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74289056",
  null
  
)

export default component.exports